import React, {useEffect, useState} from 'react';

import {Props} from './interfaces';
import './Header.scss';
import './Header-media.scss';
import './../MenuTop/MenuTop.scss';
import './../MenuTop/MenuTop-media.scss';

import {connect, WithStore, MapStateToProps, MapDispatchToProps} from '../../../redux/services/Imports';

import {MediaContent, bodyAuto, bodyHidden} from '../../../services/GlobalFunctions';
import HeaderMobPopup from '../HeaderMobPopup/HeaderMobPopup';
import MenuHamburger from '../MenuHamburger/MenuHamburger';
import {createPortal} from 'react-dom';
import {SelectValuesFormSimple} from '../../../services/content/Constants';
import ModalFormFeedback from '../../ModalFormFeedback/ModalFormFeedback';
import MenuFixed from '../MenuFixed/MenuFixed';
import {content} from "../../../services/content";

const Header = ({widthWindow, menu}: Props) => {
  const [showPopupMenu, setShowPopupMenu] = useState(false);
  const [elCheckMenu, setElCheckMenu] = useState<React.ChangeEvent<HTMLInputElement> | null>(null);
  const [contactForms, setContactForms] = useState({});

  const [showFeedback, setShowFeedback] = useState(false);
  const openFeedback = () => setShowFeedback(true);
  const closedFeedback = () => setShowFeedback(false);

  const closedMob = () => bodyAuto();
  const openPopup = () => {
    bodyHidden();
    setShowPopupMenu(true);
  };

  useEffect(() => {
    const onClick = () => setShowFeedback(true);
    const btn = document.getElementById('header-button-feedback');
    const props = btn?.dataset?.props ? JSON.parse(btn?.dataset?.props as string) : {contactForms: {}};
    setContactForms(props.contactForms);
    if (btn) {
      btn.addEventListener('click', onClick);
    }
    return () => {
      if (btn) {
        btn.removeEventListener('click', onClick);
      }
    }
  }, []);

  const closedPopup = (e?: React.ChangeEvent<HTMLInputElement> | null) => () => {
    bodyAuto();

    if (widthWindow > 720) {
      (e?.target.closest('.header')?.querySelector('.menu-popup') as HTMLElement).style.opacity = '0';
    }

    setShowPopupMenu(false);
    if (e) {
      e.target.checked = false;
    }
  };

  return (
    <>
      {MediaContent(
        <MenuFixed openFeedback={openFeedback} widthWindow={widthWindow} menu={menu}/>,
        <>
          <MenuHamburger
            onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
              e.target.checked ? openPopup() : closedPopup(elCheckMenu)();
              setElCheckMenu(e);
            }}
          />
          <HeaderMobPopup closed={closedPopup(elCheckMenu)} show={showPopupMenu} widthWindow={widthWindow} menu={menu}/>
        </>
      )}

      {createPortal(
        <ModalFormFeedback
          hasCssTransition
          showForm={showFeedback}
          id="feedback"
          title={content.header.textModalFeedback}
          select={{options: SelectValuesFormSimple}}
          closedModal={closedFeedback}
          contactForms={contactForms}
        />,
        document.body
      )}
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(Header));
